import { cssSpacing, defaultTheme, overlayBoxShadow, rootStyle, zIndexPopover } from "../../styles/index.mjs";
import styled, { css } from "../../styled-components.mjs";
export var PopoverMobile = styled.div.withConfig({
  displayName: "PopoverMobile",
  componentId: "sc-5m72cj-0"
})(["", ";", " box-shadow:", ";bottom:0;left:0;padding-block:", ";padding-inline:", ";position:fixed;text-align:center;width:100%;z-index:", ";.docs-story &{position:absolute;}"], rootStyle(), function (props) {
  return css(["background:var( --background-elevated-base,", " );"], defaultTheme[props.$colorSet].background.elevated.base);
}, overlayBoxShadow, cssSpacing('tighter', '12px'), cssSpacing('looser', '24px'), zIndexPopover);